export const CREATE_BUSINESS_WATCHER = 'CREATE_BUSINESS_WATCHER';
export const CREATE_BUSINESS_SUCCESS = 'CREATE_BUSINESS_SUCCESS';
export const CREATE_BUSINESS_FAILED = 'CREATE_BUSINESS_FAILED';
